import { API } from '../config/AppConfig';
import {
  CHART_ACCURACY_BREAKDOWN,
  PHYSICIAN_CQ_SCORE,
  PHYSICIAN_STATISTICS,
  RVU_OPP,
  TOTAL_UPLOADS,
  UPDATE_ACCURACY_REVIEW_STATUS,
} from '../constants/Endpoints';
import { applyDateType } from '../utils/common.utils';

class PhysicianRepository {
  async getPhysician(queryParams, departmentId) {
    const finalParams = applyDateType(queryParams);
    const response = await API.get(PHYSICIAN_STATISTICS, {
      queryParams: finalParams,
    });
    return response;
  }

  async getPhysicianCQScore(queryParams) {
    const finalParams = applyDateType(queryParams);
    const response = await API.get(PHYSICIAN_CQ_SCORE, { queryParams: finalParams });
    return response;
  }

  async getAuditChartAccuracy(queryParams) {
    const finalParams = applyDateType(queryParams);
    const response = await API.get(CHART_ACCURACY_BREAKDOWN, {
      queryParams: finalParams,
    });
    return response;
  }

  async getTotalUploadsData(queryParams) {
    const finalParams = applyDateType(queryParams);
    const response = await API.get(TOTAL_UPLOADS, {
      queryParams: finalParams,
    });
    return response;
  }

  async getPhysicianCQscore(queryParams) {
    const finalParams = applyDateType(queryParams);
    const response = await API.get(PHYSICIAN_CQ_SCORE, {
      queryParams: finalParams,
    });
    return response;
  }

  async getRUVoppurtunity(queryParams) {
    const finalParams = applyDateType(queryParams);
    const response = await API.get(RVU_OPP, {
      queryParams: finalParams,
    });
    return response;
  }

  async updateAccuracyReviewStatus(rowData) {
    try {
        // const { chart_id, location, review } = rowData;
        const response = await API.put(UPDATE_ACCURACY_REVIEW_STATUS, {
            body: rowData
        });
        return response.data;
    } catch (error) {
        throw new Error('Failed to update review status');
    }
  }
}

const physicianRepository = new PhysicianRepository();
export default physicianRepository;
